import { defineStore } from "pinia"
import { computed } from "vue"
import { useStorage } from "@vueuse/core"
import { MonkeyMode } from "@/enums/monkey-modes"

/** How lively the monkey is on the screen. */
export type MonkeyActivity = "relax" | "normal" | "busy"

export const useMonkeysStore = defineStore("monkeysStore", () => {
  const storedMonkeyMode = useStorage<MonkeyMode>("AppSettingsMonkey", MonkeyMode.OFF)
  const storedMonkeySound = useStorage<boolean>("AppSettingsMonkeySound", false)
  const storedMonkeyActivity = useStorage<MonkeyActivity>("AppSettingsMonkeyActivity", "normal")
  const monkeyActivity = computed<MonkeyActivity>(() =>
    ["relax", "normal", "busy"].includes(storedMonkeyActivity.value)
      ? storedMonkeyActivity.value
      : "normal"
  )
  const peanutsEaten = useStorage<number>("AppMonkeyPeanutsEaten", 0)
  const bananasEaten = useStorage<number>("AppMonkeyBananasEaten", 0)

  const isMonkeyEnabled = computed(
    () =>
      storedMonkeyMode.value === MonkeyMode.FULL || storedMonkeyMode.value === MonkeyMode.SPECIAL
  )
  const isMonkeyRoaming = computed(() => storedMonkeyMode.value === MonkeyMode.FULL)

  function setMonkeyMode(mode: MonkeyMode) {
    storedMonkeyMode.value = mode
  }

  function setMonkeySound(enabled: boolean) {
    storedMonkeySound.value = enabled
  }

  function setMonkeyActivity(activity: MonkeyActivity) {
    storedMonkeyActivity.value = activity
  }

  function registerFood(food: "peanut" | "banana") {
    if (food === "peanut") {
      peanutsEaten.value += 1
    } else {
      bananasEaten.value += 1
    }
  }

  return {
    storedMonkeyMode,
    storedMonkeySound,
    peanutsEaten,
    bananasEaten,
    isMonkeyEnabled,
    isMonkeyRoaming,
    monkeyActivity,
    setMonkeyMode,
    setMonkeySound,
    setMonkeyActivity,
    registerFood
  }
})
